import axios from '@/utils/axios';
import qs from 'qs';
import { format, getQuarter, getYear } from 'date-fns';
import DataSet from '@antv/data-set';
import { isInteger } from 'lodash-es';
import MemoryCache from './cache';

const tenThousand = Math.pow(10, 4); // 一万
const oneMillion = Math.pow(10, 6); // 100万
const oneHundMillion = Math.pow(10, 8); // 一亿
const tenBillion = Math.pow(10, 10); // 100亿

const seriesMemoryCache = new MemoryCache<Record<string, any>>();

export function formatCount(count: number) {
    if (!isInteger(count)) {
        return {
            num: count.toFixed(1),
            unit: '',
        };
    }
    if (count >= tenBillion) {
        return {
            num: parseInt((count / oneHundMillion).toString(), 10)
                .toString()
                .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'),
            unit: '亿',
        };
    }
    if (count >= oneMillion) {
        return {
            num: parseInt((count / tenThousand).toString(), 10)
                .toString()
                .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'),
            unit: '万',
        };
    }
    return {
        num: count.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'),
        unit: '',
    };
}

export function formatCountString(count: number) {
    if (!isInteger(count)) {
        return count.toFixed(2).toString();
    }
    const str = count.toString().split('');
    for (let i = str.length - 3; i > 0; i -= 3) {
        str.splice(i, 0, ',');
    }
    return str.join('');
}

export function formatDimension(
    formatType: string,
    data: Array<Record<string, any>>,
) {
    if (formatType === 'quarter') {
        data.forEach((item: Record<string, any>) => {
            item.dimension = `${getYear(+item.dimension)}年第${getQuarter(
                +item.dimension,
            )}季度`;
        });
        return data;
    }
    data.forEach((item: Record<string, any>) => {
        item.dimension = format(+item.dimension, formatType);
    });
    return data;
}

export function transformDV(
    sourceData: Array<Record<string, any>>,
    seriesNames: string[],
) {
    return new DataSet.View().source(sourceData).transform({
        type: 'fold',
        fields: seriesNames,
        key: 'chartKey',
        value: 'chartValue',
    }).rows;
}

export function getStringfyParams(
    params: Record<string, any>,
    dimensionType: number,
) {
    delete params.dateRange;
    Object.keys(params).forEach((item: string) => {
        params[item] = params[item].join(',');
    });
    params.dimensionType = dimensionType;
    return qs.stringify(params);
}
export async function getReportSeries(param: any, useCache = false) {
    if (param.dateRange?.length) {
        param.dateRangeStart = param.dateRange[0];
        param.dateRangeEnd = param.dateRange[1];
    }
    delete param.dateRange;
    if (useCache) {
        const cache = seriesMemoryCache.get(param);
        if (cache) {
            return cache;
        }
    }
    const res = await axios.post<Record<string, any>>(
        '/portal/data/report/series',
        qs.stringify(param),
    );
    if (useCache && res?.data?.result === 1 && res?.data?.data?.length > 0) {
        seriesMemoryCache.set(param, res.data);
    }
    return res?.data?.result === 1 ? res.data : {};
}
